import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPeople: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="people, user, person, avatar"><path d="M12 2C9.51472 2 7.5 4.01472 7.5 6.5C7.5 8.98528 9.51472 11 12 11C14.4853 11 16.5 8.98528 16.5 6.5C16.5 4.01472 14.4853 2 12 2Z" fill="currentColor"/><path d="M12 12.5C8.73708 12.5 6.14047 14.213 4.77277 16.7569C4.19622 17.8293 4.41122 18.9365 5.05292 19.7348C5.67643 20.5105 6.69558 21 7.79526 21H16.2047C17.3044 21 18.3236 20.5105 18.9471 19.7348C19.5888 18.9365 19.8038 17.8293 19.2272 16.7569C17.8595 14.213 15.2629 12.5 12 12.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPeople;
